import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PackInFocusState } from './pack-in-focus.models';
import { PACK_IN_FOCUS_FEATURE_KEY } from './pack-in-focus.reducer';

export const packInFocusSelector = createFeatureSelector<PackInFocusState>(PACK_IN_FOCUS_FEATURE_KEY);
// eslint-disable-next-line
export const getPackInFocusState = () => createSelector(packInFocusSelector, (state: PackInFocusState) => state);
// eslint-disable-next-line
export const getPackInFocusData = () => createSelector(packInFocusSelector, (state: PackInFocusState) => state.data);
